// extracted by mini-css-extract-plugin
export default {"support":"support_support__BwpSN"};